import { useEffect } from 'react';

/**
 * Custom hook to handle mobile viewport height changes
 * Updates CSS custom property --vh when keyboard opens/closes or browser chrome changes
 * This ensures the UI adapts properly to the actual visible viewport on mobile devices
 */
const useViewportHeight = () => {
  useEffect(() => {
    // Function to update the viewport height CSS variable
    const updateViewportHeight = () => {
      // Use visualViewport API if available (modern browsers)
      // Falls back to innerHeight for older browsers
      const vh = window.visualViewport?.height || window.innerHeight;
      const vhUnit = vh * 0.01;
      document.documentElement.style.setProperty('--vh', `${vhUnit}px`);
    };

    // Set initial value
    updateViewportHeight();

    // Listen for viewport changes
    // visualViewport is better for mobile as it accounts for keyboard
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateViewportHeight);
    } else {
      // Fallback for older browsers
      window.addEventListener('resize', updateViewportHeight);
    }

    // Also listen for orientation changes
    window.addEventListener('orientationchange', updateViewportHeight);

    // Cleanup
    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', updateViewportHeight);
      } else {
        window.removeEventListener('resize', updateViewportHeight);
      }
      window.removeEventListener('orientationchange', updateViewportHeight);
    };
  }, []);
};

export default useViewportHeight;
